const state = {
  version: '0.1.0',
  client: null,
  currentIndex: 0,
  consultSteps: {
    ClientDetails: 'Client Details',
    Mastitis: 'Mastitis',
    ReviewCalving: 'Review Calving',
    ReviewSickCows: 'Review Sick Cows',
    CalfHealth: 'Review Calf Health',
    DownCowMeta: 'Down Cow / Metabolic Issues',
    TraceElements: 'Review Trace Elements',
    ReviewReproduction: 'Review Reproduction',
    ReviewAmu: 'Review Annual Anti-Microbial Usage (AMU)',
    ReviewNsaids: 'Review NSAIDS',
    ForecastLepto: 'Forecast Lepto Program',
    ForecastScanning: 'Forecast Scanning',
    ReviewRvmAllocations: 'Drug Allocations',
    EmailNotifications: 'Email Notifications',
    Disclaimer: 'Disclaimer',
  },
  models: {},
  backendErrors: {},
  dbName: 'spring-review',
  endpoints: {
    get: '/clients/{client}/spring_review/{season}',
    post: '/clients/{client}/spring_review/{season}/save',
  },
}

const mutations = {
  setClient(state, client) {
    state.client = client
  },
  setNextSection(state) {
    if (state.currentIndex + 1 < Object.keys(state.consultSteps).length) {
      state.currentIndex++
    }
  },
  setPreviousSection(state) {
    if (state.currentIndex > 0) {
      state.currentIndex--
    }
  },
  updateStateFromAPI(state, models) {
    state.models = models
    state.signed = false
  },
}

const actions = {
  setPreviousSection({ commit }) {
    commit('setPreviousSection')
  },
  setNextSection({ commit }) {
    commit('setNextSection')
  },
  getReadOnlyData({ commit, state }, consultParams) {
    let endpoint = state.endpoints.get
      .replace('{client}', consultParams.clientId)
      .replace('{season}', consultParams.season)
    return consultFormService.getClientConsultData(endpoint).then(
      (models) => {
        state.currentIndex = 0
        commit('setClient', consultParams.clientId)
        commit('updateStateFromAPI', models)
      },
      (error) => {
        return Promise.reject(error)
      }
    )
  },
}

const getters = {
  isReadOnly: (state) => {
    return state.dbName == 'spring-review' ? true : state.models.Misc.read_only
  },
  currentComponent: (state) => {
    return Object.keys(state.consultSteps)[state.currentIndex]
  },
  currentComponentModel: (state) => {
    let key = Object.keys(state.consultSteps)[state.currentIndex]
    return state.models[key]
  },
  totalSteps: (state) => {
    return Object.keys(state.consultSteps).length
  },
  currentStep: (state) => {
    return state.currentIndex + 1
  },
  sectionBackendErrors: (state) => {
    let key = Object.keys(state.consultSteps)[state.currentIndex]
    return state.backendErrors[key]
  },
  currentClientName: (state) => {
    return (state.models.Misc || { consult_title: '' }).consult_title
  },
  seasonStartYear: (state) => {
    if (state.models.Misc) {
      return state.models.Misc.season_start_year
    }
    return ''
  },
  getStepName: (state) => (key) => {
    return state.consultSteps[key]
  },
  allBackendErrors: (state) => {
    return state.backendErrors
  },
  previousStepName: (state) => {
    let currentIndex = state.currentIndex
    let stepNames = state.consultSteps

    return Object.values(stepNames)[currentIndex - 1] || ''
  },
  nextStepName: (state) => {
    let currentIndex = state.currentIndex
    let stepNames = state.consultSteps
    return Object.values(stepNames)[currentIndex + 1] || ''
  },
}

export const springReview = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
